export default __webpack_public_path__ + "locales/hy-AM/InfoPanel.json?hash=6d16f06fff34f41aa86488e20b63ecdd";